/**
 * These are used to encode NFT trait filters into the URL of the glow.app
 * collection page.
 */
import { NftTypes } from "@glow/shared";
import { ParsedUrlQuery } from "querystring";

export const traitFiltersDecode = (
  query: ParsedUrlQuery,
): NftTypes.NftTrait[] => {
  try {
    const traits = Array.isArray(query?.trait)
      ? query.trait
      : [query.trait as string];
    return (
      traits.map((t) => {
        const trait = t.split("~");
        return {
          trait_type: trait[0],
          value: trait[1],
        };
      }) || []
    );
  } catch {
    return [];
  }
};

export const traitFiltersEncode = (filters: NftTypes.NftTrait[]): string[] => {
  return filters.map((f) => `${f.trait_type}~${f.value}`);
};
